import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const onboardingMap: genericJourneyResolverMapping[] = [
  {
    url: /\/api\/public\/accounts\/prospect/,
    response: () => ecommbx.onboardingProspectData,
    method: 'post',
  },
  {
    url: /\/api\/public\/accounts\/parameters\/\/professions/,
    response: () => ecommbx.onBoardingProfessionsListData,
    method: 'get',
  },
  {
    url: /\/api\/public\/accounts\/parameters\/\/idTypes/,
    response: () => ecommbx.onBoardingIdTypesListData,
    method: 'get',
  },
  {
    url: /\/api\/public\/accounts\/parameters\/\/countries/,
    response: () => ecommbx.onBoardingCountriesListData,
    method: 'get',
  },
];

const onboardingHandlers = onboardingMap.map(genericMapToHandlers);

export { onboardingHandlers };
